import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-740e7aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "NotFound__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "BASF logo",
    src: _imports_0
  })
], -1))
const _hoisted_2 = { class: "NotFound__bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "NotFound__bar__error" }, "404", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "NotFound__bar__sub" }, "This page isn’t available", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "NotFound__bar__text" }, " We are sorry, the link you followed may be broken, or the page may have been removed. ", -1))

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const bkgId = computed<number>(() => {
  return store.getters.getBackgroundID;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "NotFound",
    style: _normalizeStyle({
      backgroundImage: `url(${require('@/assets/bkg' + _unref(bkgId) + '.jpg')})`
    })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_Button, {
        label: "Back to login page",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
      })
    ])
  ], 4))
}
}

})